import React from "react";
import { IconButton } from "nvs-design-system/dist/IconButton";
import { IconButtonType } from "nvs-design-system/dist/IconButton/types";
import { CaretLeft } from "nvs-ds-icons";
import { Eyebrow2 } from "@/src/components/typography/components/Eyebrow";
import clsx from "clsx";
import { motion } from "framer-motion";
import { TokenTransferSteps } from "../hooks/useTokenTransferModalSteps";

type StepPaginationProps = {
  isShowing?: boolean;
  currentStep?: TokenTransferSteps;
  onBackClick?: () => void;
};

export default function StepPagination({
  isShowing,
  currentStep = TokenTransferSteps.VerifyAccount,
  onBackClick,
}: StepPaginationProps) {
  if (!isShowing) return null;

  const isTransferring = currentStep === TokenTransferSteps.Transferring;

  return (
    <div
      className={clsx(
        "absolute top-6 flex items-center gap-2.5",
        isTransferring ? "md:left-13" : "left-2 md:left-9",
      )}
    >
      {!isTransferring && <BackButtonCaretLeft onBackClick={onBackClick} />}
      <NumberPagination currentStep={currentStep} />
      <ProgressBar currentStep={currentStep} />
    </div>
  );
}

function BackButtonCaretLeft({ onBackClick }: StepPaginationProps) {
  return (
    <IconButton
      buttonType={IconButtonType.no_outline}
      onClick={onBackClick}
      aria-label="Token Transfer Step Back Button"
      className="p-0"
    >
      <CaretLeft />
    </IconButton>
  );
}

function NumberPagination({ currentStep }: StepPaginationProps) {
  return (
    <Eyebrow2 className="mt-1" aria-label="Token Transfer Current Step Number">
      {`0${currentStep}/04`}
    </Eyebrow2>
  );
}

function ProgressBar({
  currentStep = TokenTransferSteps.VerifyAccount,
}: StepPaginationProps) {
  const MAP_PROGRESS = ["-75%", "-50%", "-25%", "0%"];

  return (
    <div className="bg-gray-600 w-12 h-1 rounded overflow-hidden">
      <motion.div
        animate={{
          translateX: MAP_PROGRESS[currentStep - 1],
        }}
        transition={{ ease: "linear" }}
        className={clsx("bg-green-500 w-full h-full rounded")}
      ></motion.div>
    </div>
  );
}
